<template>
  <Nav />
  <div class="container">
    <div class="filas-container">
      <div class="filas-header">
        <h1>Filas</h1>
        <p class="text-muted">Monitoramento das filas de processamento assíncrono do sistema.</p>
      </div>

      <div class="row g-4 mt-2">
        <div class="col-md-4" v-for="fila in filas" :key="fila.route">
          <div class="card fila-card h-100" @click="$router.push(fila.route)">
            <div class="card-body d-flex flex-column">
              <div class="fila-card-icon mb-3">
                <i :class="fila.icon"></i>
              </div>
              <h5 class="card-title">{{ fila.title }}</h5>
              <p class="card-text text-muted flex-grow-1">{{ fila.description }}</p>
              <div class="mt-3">
                <span class="btn btn-sm btn-outline-primary">
                  <i class="bi bi-arrow-right me-1"></i>Ver fila
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import { mapState } from 'vuex';

export default {
  name: 'Filas',
  components: { Nav },
  data() {
    return {
      filas: [
        {
          title: 'Atualizações de dados',
          description: 'Acompanhe a fila de processamento das atualizações dos dados para novas cargas identificadas no Siconfi, ou cargas atualizadas.',
          icon: 'bi bi-cloud-download fs-2 text-primary',
          route: '/filas/atualizacao-dados-siconfi',
        },
        {
          title: 'Congelamento de dados',
          description: 'Acompanhe a fila de processamento dos congelamentos das planilhas.',
          icon: 'bi bi-file-earmark-lock fs-2 text-warning',
          route: '/filas/congelamento-planilhas',
        },
        {
          title: 'Processamento de arquivos prévios',
          description: 'Acompahe a fila de processamento dos arquivos prévios enviados.',
          icon: 'bi bi-file-earmark-arrow-up fs-2 text-success',
          route: '/filas/processamento-arquivos-previos',
        },
      ],
    };
  },
  computed: {
    ...mapState(['user']),
    userAdmin() {
      return this.user && this.user.role === 'admin';
    },
  },
  created() {
    if (!this.userAdmin) {
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
.filas-container {
  padding: 2rem 0;
}

.filas-header {
  margin-bottom: 1rem;
}

.filas-header h1 {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--azul-escuro);
}

.fila-card {
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  transition: all 0.2s ease;
}

.fila-card:hover {
  border-color: var(--azul-escuro);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.fila-card-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background-color: #f0f4ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--azul-escuro);
}
</style>
